const DEP_TYPE = "production"; // change to "development" or "production" for other envs

const ENV_CONFIG = {
  local: {
    apiUrl:   "http://localhost:5011/",
    cdnFront: process.env.REACT_APP_CDN_DEV || "",
  },
  development: {
    apiUrl:   process.env.REACT_APP_SERVER_HOSTNAME_DEV  || "",
    cdnFront: process.env.REACT_APP_CDN_DEV              || "",
  },
  production: {
    apiUrl:   process.env.REACT_APP_SERVER_HOSTNAME_PROD || "",
    cdnFront: process.env.REACT_APP_CDN_PROD             || "",
  },
};

const configuration = {
  mode: DEP_TYPE,
  ...(ENV_CONFIG[DEP_TYPE] ?? ENV_CONFIG.local),
};

export default configuration;
